import { render, staticRenderFns } from "./cuttingDock.vue?vue&type=template&id=5df0629b&scoped=true&"
import script from "./cuttingDock.vue?vue&type=script&lang=js&"
export * from "./cuttingDock.vue?vue&type=script&lang=js&"
import style0 from "./cuttingDock.vue?vue&type=style&index=0&id=5df0629b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0629b",
  null
  
)

export default component.exports